export default "__VITE_ASSET__C_EuUd3z__"